import { Capacitor } from '@capacitor/core';
import { AndroidSmsRetriever } from '@capgo/capacitor-android-sms-retriever';

import { normalizePhoneHintValue } from './normalizePhoneHintValue';

/**
 * Opens Android Phone Number Hint and returns the selected number.
 * No-ops on non-Android platforms; cancels/errors resolve to undefined.
 *
 * Applies {@link normalizePhoneHintValue} so locale-based country defaults
 * (e.g. GB → +44) are not invented on top of numbers that already include a
 * country calling code.
 */
export async function requestPhoneNumberHint(): Promise<string | undefined> {
	if (Capacitor.getPlatform() !== 'android') {
		return undefined;
	}

	try {
		const { phoneNumber } = await AndroidSmsRetriever.getPhoneNumber();
		const normalized = phoneNumber
			? normalizePhoneHintValue(phoneNumber)
			: '';
		return normalized || undefined;
	} catch {
		return undefined;
	}
}
